import { ReportingState, RootState, Application, OrganisationCounts, ProjectCounts } from '@/types';
import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';
import ReportingService from '@/services/reporting.service';

type ReportingGetter = GetterTree<ReportingState, RootState>;

export const initialState = (): ReportingState => {
  return {
    initialState,
    organisationCounts: {
      projects: 0,
      tasks: 0,
      catalogue: 0,
      devices: 0,
      sites: 0,
      users: 0,
      gateways: 0,
    },
    projectCounts: {
      tasks: 0,
      devices: 0,
      sites: 0,
      users: 0,
      gateways: 0,
    },
  };
};

export const getters: ReportingGetter = {
  reporting: (state) => state,
  organisationCounts: (state) => state.organisationCounts,
  projectCounts: (state) => state.projectCounts,
};

export const mutations: MutationTree<ReportingState> = {
  addOrganisationCounts(state, newCounts) {
    state.organisationCounts = newCounts;
  },
  addProjectCounts(state, newCounts) {
    state.projectCounts = newCounts;
  },
};

export const actions: ActionTree<ReportingState, RootState> = {
  async addOrganisationCountsAsync(context: any): Promise<OrganisationCounts | null> {
    const counts = await ReportingService.getOrganisationCounts();
    context.commit('addOrganisationCounts', counts);
    return counts;
  },
  async addProjectCountsAsync(context: any): Promise<ProjectCounts | null> {
    const counts = await ReportingService.getProjectCounts();
    context.commit('addProjectCounts', counts);
    return counts;
  },
};

export const reporting: Module<ReportingState, RootState> = {
  state: initialState(),
  getters,
  mutations,
  actions,
};
